import "./BodhiTag.css";

const COLOR_MAP = {
	// brand names (canonical)
	mist: "mist",
	lotus: "lotus",
	amethyst: "amethyst",
	hydrangea: "hydrangea",
	amber: "amber",
	clay: "clay",
	neutral: "neutral",

	// semantic / antd-style aliases
	success: "mist",
	processing: "mist",
	sage: "mist",
	green: "mist",
	cyan: "mist",

	pink: "lotus",
	magenta: "lotus",

	purple: "amethyst",
	violet: "amethyst",

	blue: "hydrangea",
	info: "hydrangea",
	geekblue: "hydrangea",

	gold: "amber",
	orange: "amber",
	yellow: "amber",
	warning: "amber",

	red: "clay",
	error: "clay",
	danger: "clay",
	volcano: "clay",

	default: "neutral",
};

const resolveVariant = (color) => {
	if (!color) return "mist";
	if (typeof color !== "string") return "neutral";
	const key = color.toLowerCase().trim();
	return COLOR_MAP[key] || "neutral";
};

const CloseIcon = () => (
	<svg width="8" height="8" viewBox="0 0 8 8" fill="none" aria-hidden="true">
		<path
			d="M1 1l6 6M7 1l-6 6"
			stroke="currentColor"
			strokeWidth="1.4"
			strokeLinecap="round"
		/>
	</svg>
);

const BodhiTag = ({
	children,
	color,
	icon,
	closable = false,
	onClose,
	className = "",
	style,
	...rest
}) => {
	const variant = resolveVariant(color);
	const cls = ["bodhi-tag", `bodhi-tag-${variant}`, className]
		.filter(Boolean)
		.join(" ");

	return (
		<span className={cls} style={style} {...rest}>
			{icon && <span className="bodhi-tag-icon">{icon}</span>}
			<span className="bodhi-tag-label">{children}</span>
			{closable && (
				<button
					type="button"
					className="bodhi-tag-close"
					onClick={onClose}
					aria-label="Remove"
				>
					<CloseIcon />
				</button>
			)}
		</span>
	);
};

export default BodhiTag;
